import tw from "twin.macro";

const Label = tw.label`block m-1 font-bold text-gray-800`;

export default Label;
